import { Popover } from "antd"
import { useState } from "react"
import { useQuery } from "react-query"
import { movePreCheck } from "./JobOperationsModel"
import MoveJobModal from "./MoveJobModal"
import { faUserXmark } from "@fortawesome/pro-solid-svg-icons"
import IconAndTextButton from "../IconAndTextButton"

export type Props = {
  jobId: number
}

const MoveJob = ({ jobId }: Props) => {
  const [moveJobModalVisible, setMoveJobModalVisible] = useState(false)
  const precheck = useQuery(['move-precheck', { jobId }], () => movePreCheck(jobId), {
    refetchOnWindowFocus: false,
    staleTime: 60000
  })
  const hasInvoices = (precheck.data?.invoiceCount ?? 0) > 0

  const button = <IconAndTextButton
    size="large"
    onClick={() => setMoveJobModalVisible(true)}
    loading={precheck.isLoading}
    disabled={hasInvoices}
    icon={faUserXmark}
    text="Move"
  />

  return <>
    {hasInvoices ?
      <Popover content="This job cannot be moved because it has already been invoiced." placement="topLeft">
        {button}
      </Popover>
      : button
    }
    {precheck.data &&
      <MoveJobModal
        visible={moveJobModalVisible}
        onClose={() => setMoveJobModalVisible(false)}
        precheck={precheck.data}
        jobId={jobId}
      />
    }
  </>
}
export default MoveJob
